var HtmlComponent_default = {
  "htmlComponent": "f-TTt",
  "htmlComponent_placeholder": "-H7Jg"
};
export {
  HtmlComponent_default as default
};
//# sourceMappingURL=HtmlComponent-scss.js.map
